import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useNavigation from "../hooks/useNavigation";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import colors from "../helper/colors";

const StackScreen = ({
    backable = true,
    backRequireConfirmation = false,
    confirmationMsg = 'Are your sure to go back?',
    backTo, //obj
    title,
    renderRight,
    children,
    onBeforeGoBack,
    theme = "light",
}) => {

    useEffect( () => {
        const metaTag = document.querySelector('meta[name="theme-color"]');
        const backgroundColor = theme === "light" ? "white" : colors.find(e => e.org === "black").soft;
        if (metaTag) {
            metaTag.setAttribute('content', backgroundColor);
        } else {
            const newMetaTag = document.createElement('meta');
            newMetaTag.name = 'theme-color';
            newMetaTag.content = backgroundColor;
            document.head.appendChild(newMetaTag);
        }
    }, []);

    const currentRoute = useSelector( state => state.router.currentRoute );
    const navigation = useNavigation();

    const goBack = () => {
        if(backable){
            if(backRequireConfirmation){
                if(window.confirm(confirmationMsg)){
                    backTo 
                        ? navigation.navigate(backTo.name, backTo.params ?? {} ) 
                        : navigation.goBack();

                    onBeforeGoBack?.();
                }
            } else {
                backTo 
                    ? navigation.navigate(backTo.name, backTo.params ?? {} ) 
                    : navigation.goBack();
                onBeforeGoBack?.();
            }
        }
    }

    return (
        <div className="flex-1 flex flex-col overflow-hidden">
            <div className={`flex flex-row h-12 items-center ${
                theme === "light" ? "bg-white border-b border-b-dim-gray" : "bg-soft-black border-b border-b-black"
            }`}>
                <div className="w-1/5 flex justify-start ml-3">
                    { backable ? (
                        <button 
                            className="flex items-center text-blue space-x-1"
                            onClick={goBack}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} size="lg"/>
                            <span className="font-semibold">
                                Back
                            </span>
                        </button>
                    ) : ''}
                </div>
                <div className="flex-1 flex justify-center">
                    <span className={`text-sm font-bold ${
                        theme === "light" ? "text-black" : "text-white"
                    }`}>
                        { title ?? currentRoute.title }
                    </span>
                </div>
                <div className="w-1/5 flex justify-end mr-3">
                    {renderRight}
                </div>
            </div>

            {children}
        </div>
    );
};

export default StackScreen;
